import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../services/supabase';
import type { VolunteerOpportunity } from './useVolunteerOpportunities';

export type UpsertVolunteerOpportunityPayload = Partial<Omit<VolunteerOpportunity, 'id'>> & {
  id?: string; // optional for insert
  thumbnail?: string | null;
};

export const useUpsertVolunteerOpportunity = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: UpsertVolunteerOpportunityPayload) => {
      const { id, ...rest } = payload;
      if (id) {
        const { data, error } = await supabase
          .from('volunteer_opportunities')
          .update(rest)
          .eq('id', id)
          .select()
          .single();
        if (error) throw error;
        return data;
      }
      const { data, error } = await supabase
        .from('volunteer_opportunities')
        .insert(rest)
        .select()
        .single();
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['volunteerOpportunities'] });
    },
  });
};
